/* Rollin'Denims · PDP conversion helpers v1
   - Fit finder: 3 taps to a size, using our own fit notes (usual waist size; between sizes take the larger;
     armour sits better with a little room)
   - Shift-Pack add-on: one tick adds the bag with the jeans */
(function () {
  'use strict';
  var ready = function (fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var inr = function (p) { return '₹' + (Number(p) / 100).toLocaleString('en-IN'); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  ready(function () {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var cfgEl = document.getElementById('rd-cro');
    if (!form || !cfgEl) return;
    var cfg = {}; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var wrap = form.closest('[data-callbackvariant]') || form.parentNode;
    var sel = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    var variants = [];
    try { variants = JSON.parse(((wrap && wrap.querySelector('.pr_variants_json')) || document.querySelector('.pr_variants_json')).textContent); } catch (e) {}
    var curVar = function () { var id = sel ? String(sel.value) : ''; for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i]; return variants[0]; };

    var sizeOpt = null, armOpt = null;
    $$('[data-swatch-option]', form).forEach(function (o) {
      var vals = $$('[data-swatch-item]', o).map(function (i) { return i.getAttribute('data-value'); });
      if (vals.indexOf('With Armour') > -1) armOpt = o;
      else if (!sizeOpt && vals.length && vals.every(function (v) { return /^\d+$/.test(v); })) sizeOpt = o;
    });

    /* ---------------- Fit finder ---------------- */
    if (cfg.fit && sizeOpt) {
      var sizes = $$('[data-swatch-item]', sizeOpt).map(function (i) { return parseInt(i.getAttribute('data-value'), 10); });
      var mine = store.get('rd_fit');
      var trig = document.createElement('div');
      trig.className = 'rd-ff__trig';
      var paint = function () {
        mine = store.get('rd_fit');
        trig.innerHTML = '<button type="button" data-rd-ff-open>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" aria-hidden="true"><path d="M4 4h16v16H4z"/><path d="M9 4v6M15 4v4M4 14h6"/></svg>' +
          (mine ? 'Your size: <b>' + esc(mine.size) + '</b><span>Change</span>' : 'Not sure of your size? <b>Find it in 3 taps</b>') + '</button>';
      };
      paint();
      var list = sizeOpt.querySelector('.t4s-swatch__list');
      if (list) list.parentNode.insertBefore(trig, list.nextSibling);

      var sheet = document.createElement('div');
      sheet.className = 'rd-ff'; sheet.hidden = true;
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-labelledby', 'rd-ff-h');
      document.body.appendChild(sheet);

      var A = {}, step = 0;
      var waistBtns = []; for (var w = 28; w <= 44; w++) waistBtns.push(w);
      var Q = [
        { k: 'waist', h: 'What waist size do your everyday jeans say?', s: 'Check the label inside the waistband. It\'s usually a number like 32.', o: waistBtns.map(String), grid: true, extra: 'I don\'t know' },
        { k: 'thigh', h: 'How do those jeans feel on your thighs?', o: ['Tight', 'Just right', 'Loose'] },
        { k: 'armour', h: 'Will you ride with knee and hip armour in?', o: ['Yes', 'No', 'Not sure yet'] }
      ];

      var close = function () { sheet.classList.remove('is-in'); document.documentElement.style.overflow = ''; setTimeout(function () { sheet.hidden = true; }, 250); };
      var open = function () {
        A = {}; step = 0; draw();
        sheet.hidden = false; document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-in'); var b = sheet.querySelector('.rd-ff__o'); if (b) b.focus({ preventScroll: true }); }); });
      };

      var pickSwatch = function (opt, val) {
        if (!opt) return;
        var it = opt.querySelector('[data-swatch-item][data-value="' + val + '"]'); if (!it) return;
        var inner = it.querySelector('input,label,span'); it.click(); if (inner && inner !== it) inner.click();
      };

      var result = function () {
        var base = parseInt(A.waist, 10), size = base, why = [];
        why.push('Go with the waist size you already wear.');
        if (size % 2) { size += 1; why.push('Between sizes, take the larger one: ' + size + '.'); }
        if (A.armour !== 'No' && A.thigh === 'Tight') { size += 2; why.push('Armour sits better with a little room, and your jeans are already tight at the thigh. Go one size up.'); }
        var top = Math.max.apply(null, sizes), low = Math.min.apply(null, sizes);
        var over = size > top, under = size < low;
        if (over) size = top; if (under) size = low;
        var wantArm = A.armour === 'Yes' ? 'With Armour' : (curVar() && curVar().option2) || 'Without Armour';
        var v = null; variants.forEach(function (x) { if (String(x.option1) === String(size) && (!x.option2 || x.option2 === wantArm)) v = v || x; });
        var cut = window.rdCut ? window.rdCut(cfg.cut) : '', note = '';
        if (A.thigh === 'Loose' && /snug|slim/.test(cut)) note = cfg.name + ' has a ' + cut + '. If you like room at the thigh, look at Outlaw, our relaxed fit.';
        if (A.thigh === 'Tight' && /relaxed/.test(cut)) note = cfg.name + ' has a relaxed fit, so it will feel roomier than your usual jeans.';
        store.set('rd_fit', { size: size, waist: base, thigh: A.thigh, armour: A.armour });
        var alts = window.rdAlts && v && !v.available ? window.rdAlts(size, wantArm) : [];
        var h = '<p class="rd-ff__eb">Your size in ' + esc(cfg.name) + '</p><p class="rd-ff__size">' + size + '</p>' +
          '<ul class="rd-ff__why">' + why.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' +
          (over || under ? '<p class="rd-ff__note">We don\'t make your exact size in ' + esc(cfg.name) + ' yet. ' + size + ' is the closest. Use "Size not listed? Request it" and we\'ll tell you if we make it.</p>' : '') +
          (note ? '<p class="rd-ff__note">' + esc(note) + '</p>' : '');
        if (v && v.available) h += '<button type="button" class="rd-ff__go" data-ff-pick>Select size ' + size + (A.armour === 'Yes' ? ', with armour' : '') + '</button>';
        else {
          h += '<p class="rd-ff__so">' + size + ' is sold out in ' + esc(cfg.name) + ' right now.</p>';
          if (alts.length) h += '<p class="rd-ff__eb">In stock in ' + size + '</p>' + alts.map(function (a) { return '<a class="rd-nm__alti" href="' + esc(a.url) + '">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" width="56" height="70" loading="lazy">' : '') + '<span><b>' + esc(a.t) + '</b><small>' + esc([a.c, a.cut].filter(Boolean).join(' · ')) + '</small></span><em>' + esc(a.price) + '</em></a>'; }).join('');
          h += '<button type="button" class="rd-ff__go is-ghost" data-ff-pick>Get notified when ' + size + ' is back</button>';
        }
        h += '<p class="rd-ff__help">Still unsure? <a href="https://wa.me/' + esc(cfg.whatsapp) + '?text=' + encodeURIComponent('Hi, I usually wear ' + base + '. Which size should I take in ' + cfg.name + '?') + '" target="_blank" rel="noopener">WhatsApp us your usual size</a>. A real person replies.</p>';
        return { html: h, size: size, arm: A.armour === 'Yes' };
      };

      var draw = function () {
        var body;
        if (step < Q.length) {
          var q = Q[step];
          body = '<p class="rd-ff__eb">Step ' + (step + 1) + ' of 3</p><h2 id="rd-ff-h" class="rd-ff__h">' + esc(q.h) + '</h2>' + (q.s ? '<p class="rd-ff__s">' + esc(q.s) + '</p>' : '') +
            '<div class="rd-ff__opts' + (q.grid ? ' is-grid' : '') + '">' + q.o.map(function (o) { return '<button type="button" class="rd-ff__o" data-ff-a="' + esc(o) + '">' + esc(o) + '</button>'; }).join('') + '</div>' +
            (q.extra ? '<button type="button" class="rd-ff__x" data-ff-sg>' + esc(q.extra) + ': measure a pair you own</button>' : '');
        } else {
          var r = result(); body = '<h2 id="rd-ff-h" class="rd-vh">Your size</h2>' + r.html; sheet._r = r;
        }
        sheet.innerHTML = '<div class="rd-ff__bg" data-ff-close></div><div class="rd-ff__p">' +
          '<div class="rd-ff__top">' + (step > 0 ? '<button type="button" class="rd-ff__back" data-ff-back>Back</button>' : '<span></span>') + '<button type="button" class="rd-ff__close" data-ff-close aria-label="Close">×</button></div>' +
          '<div class="rd-ff__bar"><i style="width:' + Math.min(100, Math.round(step / 3 * 100)) + '%"></i></div>' + body + '</div>';
      };

      sheet.addEventListener('click', function (e) {
        var t = e.target.closest('button,a,[data-ff-close]'); if (!t) return;
        if (t.hasAttribute('data-ff-close')) return close();
        if (t.hasAttribute('data-ff-back')) { step = Math.max(0, step - 1); return draw(); }
        if (t.hasAttribute('data-ff-sg')) { close(); var sg = document.querySelector('[data-rd-sg-open]'); if (sg) setTimeout(function () { sg.click(); }, 260); return; }
        if (t.hasAttribute('data-ff-a')) { A[Q[step].k] = t.getAttribute('data-ff-a'); step++; return draw(); }
        if (t.hasAttribute('data-ff-pick')) {
          var r = sheet._r; close(); paint();
          pickSwatch(sizeOpt, String(r.size));
          if (r.arm) setTimeout(function () { var c = document.querySelector('.rd-arm__card[data-rd-val="With Armour"]'); if (c) c.click(); else pickSwatch(armOpt, 'With Armour'); }, 200);
          setTimeout(function () { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
      trig.addEventListener('click', function (e) { if (e.target.closest('[data-rd-ff-open]')) open(); });
    }

    /* ---------------- Shift-Pack add-on ---------------- */
    var ad = cfg.addon;
    if (ad && ad.available && ad.id) {
      var card = document.createElement('label');
      card.className = 'rd-addon';
      card.innerHTML = '<input type="checkbox" data-rd-addon>' +
        '<span class="rd-addon__box" aria-hidden="true"></span>' +
        (ad.img ? '<img src="' + esc(ad.img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span class="rd-addon__t"><b>Add the ' + esc(ad.name) + '</b><small>' + esc(ad.sub) + '</small></span>' +
        '<span class="rd-addon__p">+' + inr(ad.price) + '</span>';
      var btns = form.querySelector('.t4s-product-form__buttons');
      if (btns) btns.parentNode.insertBefore(card, btns);
      var cb = card.querySelector('input');
      var busy = false;
      var go = function (e) {
        if (!cb.checked || busy) return;
        var v = curVar(); if (!v || !v.available) return;
        e.preventDefault(); e.stopImmediatePropagation();
        busy = true;
        var qtyEl = form.querySelector('input[name="quantity"]'), qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var b = e.currentTarget && e.currentTarget.tagName === 'BUTTON' ? e.currentTarget : null; if (b) b.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }, { id: ad.id, quantity: 1, properties: { _added_from: 'pdp' } }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add');
            location.href = '/cart';
          })
          .catch(function (err) {
            busy = false; if (b) b.classList.remove('is-loading'); cb.checked = false;
            var m = card.querySelector('.rd-addon__err') || card.appendChild(document.createElement('span'));
            m.className = 'rd-addon__err'; m.setAttribute('role', 'alert');
            m.textContent = err.message + '. Nothing was added. Untick the bag and try again.';
          });
      };
      $$('button[data-atc-form], button[name="add"]', form).forEach(function (b) { b.addEventListener('click', go, true); });
      form.addEventListener('submit', go, true);
      var sticky = document.querySelector('#rd-sticky [data-rd-s-btn]');
      if (sticky) sticky.addEventListener('click', function (e) { if (cb.checked && curVar() && curVar().available) go(e); }, true);
    }
  });
})();
